export const isVoucher = (form) => form?.voucherType;

export const getPaymentReferenceNo = (payment, epmrReceiptDetails) => {

    const cards = ["DB", "CC"];
    
    let referenceNo = "";
    if (isVoucher(payment) && !cards.includes(payment?.paymentMode)) {
        referenceNo = payment.voucherUTRKey;
    } else if (payment.referenceNumber && !epmrReceiptDetails) {
        referenceNo = payment.referenceNumber?.label ?? payment.referenceNumber;
    }
    return referenceNo;

}